const ResultCounterCard = (props) => {
    return (
        <div className="resultCounterCard g-col-4 d-flex flex-column justify-content-center align-items-center">
            <div className="cardTitle">{props.title}</div>
            <div>
                <span className="cardValue">{props.value}</span> {props.suffix}
            </div>
        </div>
    );
}

export default ResultCounterCard;